import script from "./index.vue?vue&type=script&lang=ts&setup=true&name=Layout"
export * from "./index.vue?vue&type=script&lang=ts&setup=true&name=Layout"

import "./index.vue?vue&type=style&index=0&id=06905f29&lang=scss&scoped=true"

import exportComponent from "/Users/niming/Documents/vue-mooc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06905f29"]])

export default __exports__